import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TarefasDTO } from 'src/providersdata/TarefasDTO';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class TarefasProvider {
  private header=APIService.getHeader();

  constructor(public http: HttpClient) {
  }
  
  /**
   * Lista tarefas do usuário
   * @param page - current page number
   * @param rowsPerPage - number of rows
   * @returns 
   */
  get(page: number = 0, rowsPerPage: number = 10, parametrosGestor = [], params = {}): Promise<{Item: TarefasDTO, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();
    

    const paramGestor = JSON.stringify(parametrosGestor);

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'tarefas'
      
      me.http.get(url, {
        headers: me.header,
        params: {
          page: page,
          rowsPerPage: rowsPerPage,
          parametrosGestor: paramGestor,
          ...params
        }
      })
        .subscribe((result: any) => {
          // //console.log("result", result);
          let item_ret = {
            Item: null,
            erro: ""
          }

          if(result.status_ret != "NOK") {
            item_ret.Item = result;
          }else {
            item_ret.erro = result.erro;
          }

          resolve(item_ret);
        },
        (error) => {
          const errochamada = {
            Item: null,
            erro:  error.statusText || error.error
          };

          reject(errochamada);
          
        });
    });
  }


  responderTarefa(isAprovado: boolean, params = {}): Promise<{Item: any, erro: string}>
  {

    return new Promise((res, rej) => {
      const url = APIService.API_URL + 'tarefas';

      this.http.post(url, null, {
        headers: this.header,
        params: {...params, isAprovado},
      })
      .subscribe((result: any) => {
        let item_ret = {
          Item: null,
          erro: ""
        }

        if(result?.status_ret != "NOK" || result == null) {
          item_ret.Item = result;
        }else {
          item_ret.erro = result.erro;
        }

        res(item_ret);
      },
      (error) => {
        const errochamada = {
          Item: null,
          erro: error.error
        };

        rej(errochamada);
        
      });
      
    })
  }
  
  /**
   * Resposta do comunicado pelo usuário aprovador
   * @returns 
   */
  avaliarComunicacao(isAprovado: boolean, idComunicacao: string | number, idAtividadeBPM: string | number, params = {}): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      const url = APIService.API_URL + 'tarefas';
      let operacao = "responderComunicado"

      if(params['operacao'])
      {
        operacao = params['operacao'];
      }
      
      me.http.post(url, null, {
        headers: me.header,
        params: {
          operacao,
          isAprovado,
          idComunicacao,
          idAtividadeBPM,
          ...params
        }
      })
        .subscribe((result: any) => {
          let item_ret = {
            Item: null,
            erro: ""
          }

          if(result.status_ret != "NOK") {
            item_ret.Item = result;
          }else {
            item_ret.erro = result.erro;
          }

          resolve(item_ret);
        },
        (error) => {
          const errochamada = {
            Item: null,
            erro: error.error
          };

          reject(errochamada);
          
        });
    });
  }

  
  alteracaoDataLimite(idAtividadeBPM: string, idComunicacao: number, justificativa: string, data: string): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      const url = APIService.API_URL + 'tarefas';
      
      me.http.post(url, null, {
        headers: me.header,
        params: {
          operacao: "alterarDataLimite",
          justificativa,
          data,
          idAtividadeBPM,
          idComunicacao
        }
      })
        .subscribe((result: any) => {
          let item_ret = {
            Item: null,
            erro: ""
          }

          if(result.status_ret != "NOK") {
            item_ret.Item = result;
          }else {
            item_ret.erro = result.erro;
          }

          resolve(item_ret);
        },
        (error) => {
          const errochamada = {
            Item: null,
            erro: error.error
          };

          reject(errochamada);
          
        });
    });
  }
  /**
   * Resposta do comunicado pelo usuário aprovador
   * @returns 
   */
  responderInforme(isAprovado: boolean, idAtividadeBPM: string | number, params = {}): Promise<{Item: any, erro: string}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      const url = APIService.API_URL + 'tarefas';
      
      me.http.post(url, null, {
        headers: me.header,
        params: {
          operacao: "responderInforme",
          isAprovado,
          idAtividadeBPM,
          ...params
        }
      })
        .subscribe((result: any) => {
          let item_ret = {
            Item: null,
            erro: ""
          }

          if(result.status_ret != "NOK") {
            item_ret.Item = result;
          }else {
            item_ret.erro = result.erro;
          }

          resolve(item_ret);
        },
        (error) => {
          const errochamada = {
            Item: null,
            erro: error.error
          };

          reject(errochamada);
          
        });
    });
  }

}
